import { noop } from '@crocodille/common';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../elements/modal/modal';
import ShippingInRestaurantForm from '../shipping-in-restaurant-form/shipping-in-restaurant-form';
import styles from './shipping-in-restaurant-modal.module.scss';

export interface ShippingModalProps {
  readonly open: boolean;
  onClose?(shippingPicked?: boolean): void;
  navigateToProductList?(): void;
}

const ShippingInRestaurantModal: React.FC<
  React.PropsWithChildren<ShippingModalProps>
> = ({ children, open, onClose = noop, navigateToProductList }) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeOnOutsideClick={true}
      title={t('shipping.shipping_choice')}
      showCloseButton={true}
      hideTitle={true}
      height="fill"
      width="auto"
      dialogClassName={styles.modalPadding}
    >
      <div className={styles.container}>
        <div className={styles.switchContainer}> {children}</div>
        <div className={styles.formContainer}>
          <ShippingInRestaurantForm
            navigateToProductList={navigateToProductList}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ShippingInRestaurantModal;
